import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';

import { cardStyles as styles } from './index';

const TitlesToWorkReport = () => {
  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'titles-to-work-report',
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Titles To Work Report</Text>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default TitlesToWorkReport;
